import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_FocusedObject = {
    _v1: {
        // setFocusStatusByTabId: {method: HttpMethod.POST, path: '/v1/focus-object/set-focus-status'},
        // updateFocusData: {method: HttpMethod.POST, path: '/v1/focus-object/focus'},
        // releaseObject: {method: HttpMethod.POST, path: '/v1/focus-object/release'},
        // releaseByTabId: {method: HttpMethod.POST, path: '/v1/focus-object/release-tab'}, // Tab Id is sent as header, so we know what tab to release.
        update: { method: HttpMethod.POST, path: '/v1/focus-object/update' },
    }
};
//# sourceMappingURL=api-def.js.map